// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Styles */
.header-wrapper {
    width: 100%;
}

.header {
    height: 60px;
    background: linear-gradient(90deg, rgba(45, 115, 179, 1) 0%, rgba(45, 115, 179, 1) 35%, rgba(4, 76, 143, 1) 100%);
    display: flex;
    align-items: center;
    padding: 0 20px;
}

.header-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
}

.header-logo {
    font-size: var(--logo-font-size);
    font-weight: bold;
    color: var(--header-logo-color);
    margin-right: 20px;
    min-width: 175px;
}

.header-dropdown {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-right: 16px;
}

.header-select-label {
    color: var(--select-color);
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
}

.folder-select {
    width: 250px;
    height: 36px;
    padding: 8px 12px;
    font-size: var(--main-font-size);
    border: 1px solid var(--lines-color);
    border-radius: 4px;
    background-color: transparent;
    color: var(--select-color);
    cursor: pointer;
}

.folder-select.collection-select {
    width: 140px;
}

.folder-select.patient-select {
    width: 170px;
}

.header-breadcrumbs {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 4px;
    color: var(--select-color);
    font-size: 14px;
    white-space: nowrap;
}

.header-breadcrumbs__sep {
    opacity: 0.65;
}

.header-breadcrumbs__item {
    font-weight: 400;
    opacity: 0.95;
}

.folder-select:focus {
    outline: none;
    border-color: var(--lines-color);
    box-shadow: none;
}

.folder-select option {
    background-color: var(--main-bg);
    color: var(--main-color);
}

.header-spacer {
    flex: 1 1;
}

.header-user-panel {
    display: flex;
    align-items: center;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--select-color);
}

.user-name {
    font-size: 16px;
    font-weight: 200;
}

.logout-button {
    background: none;
    border: none;
    color: var(--select-color);
    cursor: pointer;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.logout-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.login-button {
    background: none;
    border: none;
    color: var(--select-color);
    cursor: pointer;
    font-size: 16px;
    font-weight: 200;
    padding: 8px 16px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.login-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

/* Login Modal Styles */
.login-modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(15, 23, 42, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
}

.login-modal {
    background: var(--main-bg);
    border-radius: 10px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.25);
    overflow: hidden;
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.login-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 18px 22px;
    border-bottom: 1px solid var(--lines-color-light);
}

.login-modal-header h3 {
    margin: 0;
    color: var(--main-color);
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.2;
}

.close-button {
    background: none;
    border: none;
    font-size: 22px;
    line-height: 1;
    color: var(--icon-color);
    cursor: pointer;
    padding: 4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    flex-shrink: 0;
}

.close-button:hover {
    background-color: var(--select-hover-bg);
}

.login-form {
    padding: 22px;
}

.login-mode-toggle {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 18px;
}

.login-mode-btn {
    padding: 8px 10px;
    border: 1px solid var(--lines-color);
    border-radius: 6px;
    background: #f8fafc;
    color: var(--main-color);
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.login-mode-btn.active {
    background: #e0f2fe;
    border-color: #7dd3fc;
    color: #0c4a6e;
}

.login-mode-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.login-form-error {
    margin: 0 0 16px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
    font-size: 0.875rem;
    line-height: 1.4;
}

.login-form-field {
    margin-bottom: 16px;
}

.login-form-field label {
    display: block;
    margin-bottom: 6px;
    color: var(--main-color);
    font-size: 0.875rem;
    font-weight: 600;
    text-align: left;
}

.login-form-input {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid var(--lines-color);
    border-radius: 6px;
    font-size: 0.9375rem;
    color: var(--main-color);
    background-color: var(--main-bg);
}

.login-form-input:focus {
    outline: none;
    border-color: var(--btn);
    box-shadow: 0 0 0 3px rgba(2, 136, 209, 0.15);
}

.login-form-input:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #f8fafc;
}

.login-form-hint {
    margin: 4px 0 0;
    padding: 10px 12px;
    border-radius: 6px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-size: 0.8125rem;
    line-height: 1.45;
}

.login-form-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
}

.login-form-btn {
    min-width: 88px;
    padding: 9px 16px;
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.login-form-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.login-form-btn--secondary {
    background-color: var(--main-bg);
    color: var(--main-color);
    border: 1px solid var(--lines-color);
}

.login-form-btn--secondary:hover:not(:disabled) {
    background-color: var(--select-hover-bg);
}

.login-form-btn--primary {
    background-color: var(--btn);
    color: #fff;
    border: 1px solid var(--btn);
}

.login-form-btn--primary:hover:not(:disabled) {
    background-color: var(--btn-hover);
    border-color: var(--btn-hover);
}

.deep-link-warning {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 16px;
    background: #fef3c7;
    border-bottom: 1px solid #f59e0b;
    color: #92400e;
    font-size: 14px;
    line-height: 1.4;
    text-align: left;
}

.deep-link-warning__text {
    flex: 1 1;
}

.deep-link-warning__dismiss {
    flex-shrink: 0;
    border: none;
    background: transparent;
    color: #92400e;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
}

.deep-link-warning__dismiss:hover {
    color: #78350f;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iHAAiH;IACjH,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,oCAAoC;IACpC,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,QAAQ;IACR,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,8CAA8C;IAC9C,gBAAgB;IAChB,gBAAgB;IAChB,gGAAgG;AACpG;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,SAAS;IACT,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,kFAAkF;AACtF;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kFAAkF;AACtF;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* Header Styles */\n.header-wrapper {\n    width: 100%;\n}\n\n.header {\n    height: 60px;\n    background: linear-gradient(90deg, rgba(45, 115, 179, 1) 0%, rgba(45, 115, 179, 1) 35%, rgba(4, 76, 143, 1) 100%);\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.header-logo {\n    font-size: var(--logo-font-size);\n    font-weight: bold;\n    color: var(--header-logo-color);\n    margin-right: 20px;\n    min-width: 175px;\n}\n\n.header-dropdown {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-right: 16px;\n}\n\n.header-select-label {\n    color: var(--select-color);\n    font-size: 14px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.folder-select {\n    width: 250px;\n    height: 36px;\n    padding: 8px 12px;\n    font-size: var(--main-font-size);\n    border: 1px solid var(--lines-color);\n    border-radius: 4px;\n    background-color: transparent;\n    color: var(--select-color);\n    cursor: pointer;\n}\n\n.folder-select.collection-select {\n    width: 140px;\n}\n\n.folder-select.patient-select {\n    width: 170px;\n}\n\n.header-breadcrumbs {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-left: 4px;\n    color: var(--select-color);\n    font-size: 14px;\n    white-space: nowrap;\n}\n\n.header-breadcrumbs__sep {\n    opacity: 0.65;\n}\n\n.header-breadcrumbs__item {\n    font-weight: 400;\n    opacity: 0.95;\n}\n\n.folder-select:focus {\n    outline: none;\n    border-color: var(--lines-color);\n    box-shadow: none;\n}\n\n.folder-select option {\n    background-color: var(--main-bg);\n    color: var(--main-color);\n}\n\n.header-spacer {\n    flex: 1;\n}\n\n.header-user-panel {\n    display: flex;\n    align-items: center;\n}\n\n.user-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--select-color);\n}\n\n.user-name {\n    font-size: 16px;\n    font-weight: 200;\n}\n\n.logout-button {\n    background: none;\n    border: none;\n    color: var(--select-color);\n    cursor: pointer;\n    font-size: 12px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.logout-button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.login-button {\n    background: none;\n    border: none;\n    color: var(--select-color);\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 200;\n    padding: 8px 16px;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.login-button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Login Modal Styles */\n.login-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background-color: rgba(15, 23, 42, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 16px;\n}\n\n.login-modal {\n    background: var(--main-bg);\n    border-radius: 10px;\n    width: 100%;\n    max-width: 420px;\n    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.25);\n    overflow: hidden;\n    text-align: left;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n\n.login-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 18px 22px;\n    border-bottom: 1px solid var(--lines-color-light);\n}\n\n.login-modal-header h3 {\n    margin: 0;\n    color: var(--main-color);\n    font-size: 1.125rem;\n    font-weight: 600;\n    line-height: 1.2;\n}\n\n.close-button {\n    background: none;\n    border: none;\n    font-size: 22px;\n    line-height: 1;\n    color: var(--icon-color);\n    cursor: pointer;\n    padding: 4px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    flex-shrink: 0;\n}\n\n.close-button:hover {\n    background-color: var(--select-hover-bg);\n}\n\n.login-form {\n    padding: 22px;\n}\n\n.login-mode-toggle {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    margin-bottom: 18px;\n}\n\n.login-mode-btn {\n    padding: 8px 10px;\n    border: 1px solid var(--lines-color);\n    border-radius: 6px;\n    background: #f8fafc;\n    color: var(--main-color);\n    font-size: 0.8125rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.login-mode-btn.active {\n    background: #e0f2fe;\n    border-color: #7dd3fc;\n    color: #0c4a6e;\n}\n\n.login-mode-btn:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n}\n\n.login-form-error {\n    margin: 0 0 16px;\n    padding: 10px 12px;\n    border-radius: 6px;\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n    font-size: 0.875rem;\n    line-height: 1.4;\n}\n\n.login-form-field {\n    margin-bottom: 16px;\n}\n\n.login-form-field label {\n    display: block;\n    margin-bottom: 6px;\n    color: var(--main-color);\n    font-size: 0.875rem;\n    font-weight: 600;\n    text-align: left;\n}\n\n.login-form-input {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 10px 12px;\n    border: 1px solid var(--lines-color);\n    border-radius: 6px;\n    font-size: 0.9375rem;\n    color: var(--main-color);\n    background-color: var(--main-bg);\n}\n\n.login-form-input:focus {\n    outline: none;\n    border-color: var(--btn);\n    box-shadow: 0 0 0 3px rgba(2, 136, 209, 0.15);\n}\n\n.login-form-input:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    background-color: #f8fafc;\n}\n\n.login-form-hint {\n    margin: 4px 0 0;\n    padding: 10px 12px;\n    border-radius: 6px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    color: #475569;\n    font-size: 0.8125rem;\n    line-height: 1.45;\n}\n\n.login-form-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.login-form-btn {\n    min-width: 88px;\n    padding: 9px 16px;\n    border-radius: 6px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.login-form-btn:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n}\n\n.login-form-btn--secondary {\n    background-color: var(--main-bg);\n    color: var(--main-color);\n    border: 1px solid var(--lines-color);\n}\n\n.login-form-btn--secondary:hover:not(:disabled) {\n    background-color: var(--select-hover-bg);\n}\n\n.login-form-btn--primary {\n    background-color: var(--btn);\n    color: #fff;\n    border: 1px solid var(--btn);\n}\n\n.login-form-btn--primary:hover:not(:disabled) {\n    background-color: var(--btn-hover);\n    border-color: var(--btn-hover);\n}\n\n.deep-link-warning {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 10px 16px;\n    background: #fef3c7;\n    border-bottom: 1px solid #f59e0b;\n    color: #92400e;\n    font-size: 14px;\n    line-height: 1.4;\n    text-align: left;\n}\n\n.deep-link-warning__text {\n    flex: 1;\n}\n\n.deep-link-warning__dismiss {\n    flex-shrink: 0;\n    border: none;\n    background: transparent;\n    color: #92400e;\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 4px;\n}\n\n.deep-link-warning__dismiss:hover {\n    color: #78350f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
